// Experimental Inventory & Rentals module (מלאי והשכרות). The whole route group is gated by the
// per-user 'inventory' grant — users without it are redirected by guardHavePermission.
export default [
    {
        path: '/inventory',
        name: 'inventory',
        component: () => import('@/components/Inventory/Inventory'),
        meta: {
            requiresAuth: true,
            havePermission: 'inventory',
            matchHeight: true
        }
    },
    // מצב תצוגה ללקוח of the catalogue: the items as a full-screen gallery for the customer to look at (no costs, no
    // profit, prices only when the presenter switches them on) - opened from the catalogue page, or by its URL on a
    // second screen
    {
        path: '/inventory/present',
        name: 'InventoryPresentation',
        component: () => import('@/components/Inventory/InventoryPresentation'),
        meta: {
            requiresAuth: true,
            havePermission: 'inventory'
        }
    }
]
